import React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Chip from "@mui/material/Chip";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import TuneIcon from "@mui/icons-material/Tune";
import BadgeIndicator from "../common/BadgeIndicator";
import { Grid } from "@mui/material"
import './index.css'
import InputSearch from "../common/InputSearch";
import AddChip from "../common/ActionChip/AddChip";
import { useNavigate } from "react-router-dom";


export default function ElementsListingActions({ selectedProject }: any) {
  const navigate = useNavigate()

  return (
    <React.Fragment>
      <CssBaseline />
      <div className="elements-listing-actions-toolbar-box" >
        <span className="elements-listing-actions-toolbar__item-left">
          <InputSearch
            name='number'
            value={''}
            placeholder="Nombre de elemento"
            onChange={() => { }}
            onSubmitSearch={() => { }}
            onResetSearch={() => { }}
          />
        </span>

        {(selectedProject) && (

          <div className="elements-listing-actions-toolbar__item-right">
            <BadgeIndicator
              element={(<Chip
                icon={<TuneIcon color="success" />}
                label="Filtros"
                clickable
                onClick={() => { }} />)
              }
              indicator={null}
            />

            <AddChip
              onClick={() => navigate('/element/create')}
              label='Nuevo Elemento'
            />

          </div>
        )}

      </div>
    </React.Fragment>
  );
}
